var cssua=function(n,l,p){var q=/\s*([\-\w ]+)[\s\/\:]([\d_]+\b(?:[\-\._\/]\w+)*)/,r=/([\w\-\.]+[\s\/][v]?[\d_]+\b(?:[\-\._\/]\w+)*)/g,s=/\b(?:(blackberry\w*|bb10)|(rim tablet os))(?:\/(\d+\.\d+(?:\.\w+)*))?/,t=/\bsilk-accelerated=true\b/,u=/\bfluidapp\b/,v=/(\bwindows\b|\bmacintosh\b|\blinux\b|\bunix\b)/,w=/(\bandroid\b|\bipad\b|\bipod\b|\bwindows phone\b|\bwpdesktop\b|\bxblwp7\b|\bzunewp7\b|\bwindows ce\b|\bblackberry\w*|\bbb10\b|\brim tablet os\b|\bmeego|\bwebos\b|\bpalm|\bsymbian|\bj2me\b|\bdocomo\b|\bpda\b|\bchtml\b|\bmidp\b|\bcldc\b|\w*?mobile\w*?|\w*?phone\w*?)/,
x=/(\bxbox\b|\bplaystation\b|\bnintendo\s+\w+)/,k={parse:function(b,d){var a={};d&&(a.standalone=d);b=(""+b).toLowerCase();if(!b)return a;for(var c,e,g=b.split(/[()]/),f=0,k=g.length;f<k;f++)if(f%2){var m=g[f].split(";");c=0;for(e=m.length;c<e;c++)if(q.exec(m[c])){var h=RegExp.$1.split(" ").join("_"),l=RegExp.$2;if(!a[h]||parseFloat(a[h])<parseFloat(l))a[h]=l}}else if(m=g[f].match(r))for(c=0,e=m.length;c<e;c++)h=m[c].split(/[\/\s]+/),h.length&&"mozilla"!==h[0]&&(a[h[0].split(" ").join("_")]=h.slice(1).join("-"));
w.exec(b)?(a.mobile=RegExp.$1,s.exec(b)&&(delete a[a.mobile],a.blackberry=a.version||RegExp.$3||RegExp.$2||RegExp.$1,RegExp.$1?a.mobile="blackberry":"0.0.1"===a.version&&(a.blackberry="7.1.0.0"))):x.exec(b)?(a.game=RegExp.$1,c=a.game.split(" ").join("_"),a.version&&!a[c]&&(a[c]=a.version)):v.exec(b)&&(a.desktop=RegExp.$1);a.intel_mac_os_x?(a.mac_os_x=a.intel_mac_os_x.split("_").join("."),delete a.intel_mac_os_x):a.cpu_iphone_os?(a.ios=a.cpu_iphone_os.split("_").join("."),delete a.cpu_iphone_os):a.cpu_os?
(a.ios=a.cpu_os.split("_").join("."),delete a.cpu_os):"iphone"!==a.mobile||a.ios||(a.ios="1");a.opera&&a.version?(a.opera=a.version,delete a.blackberry):t.exec(b)?a.silk_accelerated=!0:u.exec(b)&&(a.fluidapp=a.version);a.edge&&(delete a.applewebkit,delete a.safari,delete a.chrome,delete a.android);if(a.applewebkit)a.webkit=a.applewebkit,delete a.applewebkit,a.opr&&(a.opera=a.opr,delete a.opr,delete a.chrome),a.safari&&(a.chrome||a.crios||a.fxios||a.opera||a.silk||a.fluidapp||a.phantomjs||a.mobile&&
!a.ios?(delete a.safari,a.vivaldi&&delete a.chrome):a.safari=a.version&&!a.rim_tablet_os?a.version:{419:"2.0.4",417:"2.0.3",416:"2.0.2",412:"2.0",312:"1.3",125:"1.2",85:"1.0"}[parseInt(a.safari,10)]||a.safari);else if(a.msie||a.trident)if(a.opera||(a.ie=a.msie||a.rv),delete a.msie,delete a.android,a.windows_phone_os)a.windows_phone=a.windows_phone_os,delete a.windows_phone_os;else{if("wpdesktop"===a.mobile||"xblwp7"===a.mobile||"zunewp7"===a.mobile)a.mobile="windows desktop",a.windows_phone=9>+a.ie?
"7.0":10>+a.ie?"7.5":"8.0",delete a.windows_nt}else if(a.gecko||a.firefox)a.gecko=a.rv;a.rv&&delete a.rv;a.version&&delete a.version;return a},format:function(b){var d="",a;for(a in b)if(a&&b.hasOwnProperty(a)){var c=a,e=b[a],c=c.split(".").join("-"),g=" ua-"+c;if("string"===typeof e){for(var e=e.split(" ").join("_").split(".").join("-"),f=e.indexOf("-");0<f;)g+=" ua-"+c+"-"+e.substring(0,f),f=e.indexOf("-",f+1);g+=" ua-"+c+"-"+e}d+=g}return d},encode:function(b){var d="",a;for(a in b)a&&b.hasOwnProperty(a)&&
(d&&(d+="\x26"),d+=encodeURIComponent(a)+"\x3d"+encodeURIComponent(b[a]));return d}};k.userAgent=k.ua=k.parse(l,p);l=k.format(k.ua)+" js";n.className=n.className?n.className.replace(/\bno-js\b/g,"")+l:l.substr(1);return k}(document.documentElement,navigator.userAgent,navigator.standalone);
/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AECookie = (function(){
	/*
	DEPENDENCIES: AE
	*/

	var APP = {
		init:function() {
			APP.props = {
				cookiesEnabled: APP._checkCookiesEnabled
			};

			if ( APP.props.cookiesEnabled() ) APP.refresh();
		},
		_checkCookiesEnabled: function () {
            var _cookiesEnabled = (navigator.cookieEnabled) ? true : false;
            if (typeof navigator.cookieEnabled == "undefined" && !_cookiesEnabled) {
                document.cookie = "testcookie";
                _cookiesEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
            }
            return _cookiesEnabled;
        },
		refresh:function() {
			//console.log(document.cookie);
			var arrCookies = document.cookie.split('; ');
			for(var i=0;i<arrCookies.length;i++) {
				var arrCookie = arrCookies[i].split('=');
				APP.props[arrCookie[0]] = arrCookie[1];
			}
			//console.log(APP.props);
		},
		read:function(name) {
			APP.refresh();
			if (name && name.length){
				return APP.props[name];
			} else {
				return APP.props;
			}
		},
		update:function(name,value,daysToLive,encodeValue) {
			// THIS FUNCTION ALWAYS RESETS THE VALUE AND EXPIRATION OF THE COOKIE
			APP.create(name,value,daysToLive,encodeValue);
		},
		exists:function(name){
			var exists = (document.cookie.indexOf(name) > -1) ? true : false;
			return exists;
		},
		expire:function(name,daysToLive){
			cookieValue = APP.read(name);
			if(cookieValue || typeof cookieValue === 'string'){
				// Only edit the expiration of an existing cookie without altering its value
				APP.update(name,APP.read(name),daysToLive);
			}
		},
		create:function(name,value,daysToLive,encodeValue) {
			//console.log('create:');
			//console.log(name+', '+value+', '+daysToLive+', '+encodeValue);
			value = value || '';
			encodeValue = encodeValue || false;
			if(typeof value === 'string') value = value.trim();
			if(encodeValue) value = encodeURIComponent(value);
			//console.log(value);
			var cookieString = name+'='+value+'; path=/'+AEdata.sameSiteCookieString;
			if(daysToLive && $.isNumeric(daysToLive)){
				var expireDate = new Date();
				expireDate.setTime(expireDate.getTime()+(daysToLive*24*60*60*1000));
				cookieString += '; expires='+expireDate.toGMTString();
			}
			document.cookie = cookieString;
			APP.refresh();
		},
		new:function(settings) {
			// Example: {name: 'stuff', value: 'stuff', encodeValue: 'stuff', daysToLive: 1, minutesToLive: 0}
			//console.log('new:');
			//console.log(settings);

			// Use local variables so we don't have to type "settings.something" all the time.
			var name 			= settings.name				|| '',
				value 			= settings.value			|| false,
				encodeValue 	= settings.encodeValue		|| false,
				daysToLive 		= settings.daysToLive		|| 0,
				minutesToLive 	= settings.minutesToLive	|| 0,
				expireDate 	 	= new Date();

			// Encode value if necessary.
			if(typeof value === 'string') value = value.trim();
			if(encodeValue) value = encodeURIComponent(value);

			// Establish beginning of cookie string.
			var cookieString = name+'='+value+'; path=/;'+AEdata.sameSiteCookieString;

			// Add days and minutes, which both default to zero.
			expireDate.setTime( expireDate.getTime() + (daysToLive * 24 * 60 * 60 * 1000) );
			expireDate.setTime( expireDate.getTime() + (minutesToLive * 60 * 1000) );

			// Add to cookie string.
			cookieString += '; expires='+expireDate.toGMTString();

			document.cookie = cookieString;
			APP.refresh();
		},
		destroy:function(name) {
			APP.update(name,'',-1);
		}
	};
	return APP;
})();

AECookie.init();
/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AECustomDimension = (function(){
	/*
	DEPENDENCIES:

	ESTABLISHED DIMENSIONS IN GOOGLE ANALYTICS
		dimension1		// Optimizely active? (Currently not used)
		dimension2		// Form Path Tracking
		dimension3		// User ID
		dimension4		// Number of Visits at Checkout
		dimension5		// Round Trip of One Way
		dimension6		// Pickup Location
		dimension7		// Drop off Location
		dimension8		// Search Locations
		dimension9		// Credit Card Used?
		dimension10		// Number of Matrix Interactions
		dimension11		// Affilate Name (Removed set for lack of reliability)
		dimension12		// Dynamic Remarketing Item ID
		dimension13		// Dynamic Remarketing Item ID2
		dimension14		// Dynamic Remarketing Page Type

	NOTES:
	// was using session storage but iPhones in Private Browsing will not work using this feature, change to JS object
	*/

	var APP = {
		init:function() {
			APP.props = {
				$page_type 				: oSite.path_info,									// Set the funnel value as property
				$search_params			: oSite.searchParams,								// Set search params as property
				$direction				: '',												// Search Custom Dimension
				$pickup					: '',												// Search Custom Dimension
				$dropoff				: '',												// Search Custom Dimension
				$locname				: '',												// Search Custom Dimension
				$loctype				: '',												// Search Custom Dimension
				$url_id1				: APP.getURLParameter("dynx_id"),					// Dynamic Remarketing Custom Dimension
				$url_id2				: APP.getURLParameter("dynx_id2"),					// Dynamic Remarketing Custom Dimension
				$url_id3				: APP.getURLParameter("dynx_page"),					// Dynamic Remarketing Custom Dimension
				$siteDomain 			: (window.location.hostname).replace("www.",""),	// Set Domain
				$pagePath 				: location.href,									// Set Page Path
				$cn_NumberVisits		: 'NumberVisits',									// Cookie Name
				$cn_FormPathTracking	: 'FormPathTracking',								// Cookie Name
				$cn_user_id				: 'user_id',										// Cookie Name
				$cn_cc_used				: 'cc_used',										// Cookie Name
				CookieValueArray		: [],												// Setup CookieValueArray to store cookie values for the page until the next header request when they will be saved.
				$numVisits				: 0,												// keep track of value
				$visitsIncreased		: false,											// Increased Number of Visits Cookie
				$ccValue				: '',												// Credit Card Value
				$ccUsed					: false												// Customer Used CC
			};

			// if Search Params Object is not empty parse JSON
			if (APP.props.$search_params !== null && APP.props.$search_params !== '') {
				APP.props.$search_params = JSON.parse(APP.props.$search_params);

				APP.props.$direction = APP.props.$search_params.TRIPTYPE;
				APP.props.$pickup	 = APP.props.$search_params.PUCODE;
				APP.props.$dropoff = APP.props.$search_params.DOCODE;
				APP.props.$locname = APP.props.$search_params.PUCITY;
				APP.props.$loctype = APP.props.$search_params.LOCTYPE;
			} else {
				APP.props.$search_params = '';
			}

			// SET SEARCH CUSTOM DIMENSIONS
			// ============================

			// ROUND TRIP OR ONE WAY RENTAL
			if (typeof APP.props.$direction !== 'undefined') {
				APP.setDimension('dimension5',APP.props.$direction);
			}
			// PICKUP COUNTRY CODE
			if (typeof APP.props.$pickup !== 'undefined') {
				APP.setDimension('dimension6',APP.props.$pickup);
				APP.setDimension('dimension12',APP.props.$pickup);	// remarketing custom dimension	pickup country code
			}
			// DROP OFF COUNTRY CODE
			if (typeof APP.props.$dropoff !== 'undefined') {
				APP.setDimension('dimension7',APP.props.$dropoff);
			}
			// LOCATION NAME OF PICKUP CITY
			if (typeof APP.props.$locname !== 'undefined') {
				APP.setDimension('dimension13',APP.props.$locname);	// remarketing custom dimension pickup location name
			}
			// LOCATION TYPE
			if (typeof APP.props.$loctype !== 'undefined') {
				APP.setDimension('dimension8',APP.props.$loctype);
			}

			// SET CUSTOM DIMENSIONS BY PAGE
			// =============================

			// ROOT OR HOME
			if (APP.props.$page_type === "/"){
				if (APP.props.$url_id1 !== null) {APP.setDimension('dimension12',APP.props.$url_id1);}
				if (APP.props.$url_id2 !== null) {APP.setDimension('dimension13',APP.props.$url_id2);}
				dimension14 = (APP.props.$url_id3 !== null) ? 'offerdetail' : 'home';		// Set home page unless remarketing link then spoof a detail page

				APP.setDimension('dimension14',dimension14);
			}

			// GET RATES MATRIX RESULTS
			else if ( APP.props.$page_type === "/results/" ) {
				APP.setDimension('dimension14','offerdetail');
				//VM
			}

			// CHECKOUT OR BOOKFORM
			else if ( APP.props.$page_type === "/checkout/" ) {
				APP.setDimension('dimension14','conversionintent');
			}

			// CONFIRMATION OR MAKEBOOKING
			else if ( APP.props.$page_type === "/confirmation/" ) {
				APP.setDimension('dimension14','conversion');

				var numVisits = APP.getCurrentCookieValue(APP.props.$cn_NumberVisits);
				if ( numVisits !== '0') {
					APP.setDimension('dimension4', numVisits);
				}
				APP.updateSingleValueCookie(APP.props.$cn_NumberVisits, 0, 365*10);
				APP.props.$visitsIncreased = true;
				APP.props.$numVisits = numVisits;


				var cc_used_value = APP.getCurrentCookieValue(APP.props.$cn_cc_used);
				if (typeof cc_used_value != 'undefined') {
					APP.setDimension('dimension9', cc_used_value);	//Send the cc_used value
					APP.props.$ccValue = cc_used_value;
					APP.props.$ccUsed = true;
				}
			}

		},
		// Send dimension data to dataLayer for GTM
		setDimension:function(dimension, value){
			if (typeof value !== 'undefined' && value !== ''){
				var objCD = {};
				objCD[dimension] = value;
				aeDataLayer.push(objCD);
			}
		},
		// THESE FUNCTION WERE PULLED FROM HALL SCRIPT MAY BE DUPLICATE FOR NOW EASIER TO USE AS IS
		// Get URL params for passed in parameter
		getURLParameter:function(name){
			return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)', 'i').exec(location.search)||[,""])[1].replace(/\+/g, '%20'))||null;
		},
		// Get the Current Cookie Value of the Specified Cookie
		getCookieValue: function(c_name) {
			var i,x,y,ARRcookies=document.cookie.split(";");
			for (i=0;i<ARRcookies.length;i++) {
				x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
				y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
				x=x.replace(/^\s+|\s+$/g,"");
				if (x==c_name) {
					var Cookie_Value = unescape(y);
				}
			}
			return Cookie_Value;
		},
		// Get the Current Cookie Value of the Specified Cookie
		doesCookieExist: function(c_name) {
			var i,x,y,ARRcookies=document.cookie.split(";");
			for (i=0;i<ARRcookies.length;i++) {
				x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
				y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
				x=x.replace(/^\s+|\s+$/g,"");
				if (x==c_name) {
					return true;
				}
			}
			return false;
		},
		// Set cookie value based on params
		setCookieValue: function (cookie_name, NewCookieValue, DaysSavedFor) {
			var theDate = new Date();
			var TimeValue = DaysSavedFor * (24 * 60 * 60 * 1000);
			var ExpirationDate = new Date( theDate.getTime() + TimeValue );
			var expiryDate = ExpirationDate.toGMTString();
			if(parseInt(TimeValue, 10) > 0) {
				document.cookie = cookie_name + "=" + NewCookieValue + "; path=/; domain="+APP.props.$siteDomain+"; expires=" + expiryDate;
			} else {
				document.cookie = cookie_name + "=" + NewCookieValue + "; path=/; domain="+APP.props.$siteDomain;
			}
		},
		// Build the basic starting cookie values for cookies that have not been set for the specific user yet.
		buildCookie: function(theCookie) {
			// Status Dimensions
			if(theCookie == APP.props.$cn_NumberVisits) {
				return '0';
			}
			if(theCookie == APP.props.$cn_FormPathTracking) {
				return '000000';
			}
			return '';
		},
		// Check if the global variable for this cookie is set yet. if so use that value, else find the value of the cookie when the page loaded
		getCurrentCookieValue: function(type) {
			if(APP.props.CookieValueArray[type]) {
				return CookieValueArray[type];
			} else {
				if(APP.doesCookieExist(type)) {
					return APP.getCookieValue(type);
				} else {
					return APP.buildCookie(type);
				}
			}
		},
		// Update the Value of Cookie
		updateSingleValueCookie: function(theCookie, theValue, DaysSavedFor) {
			APP.setCookieValue(theCookie, theValue, DaysSavedFor);
			switch(theCookie) {
				case APP.props.$cn_FormPathTracking:
					APP.setDimension('dimension2',theValue);
					break;
				case APP.props.$cn_user_id:
					APP.setDimension('dimension3',theValue);
					break;
			}
		},
		// Make ID
		makeid: function() {
			var text = "";
			var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			for( var i=0; i < 16; i++ )
				text += possible.charAt(Math.floor(Math.random() * possible.length));
			return text;
		},
		// Add to Number of Visits
		incrementNumberOfVisits: function() {
			var CurrentNumberVisits = APP.getCurrentCookieValue(APP.props.$cn_NumberVisits);
			var NewNumberVisits = parseInt(CurrentNumberVisits, 10) + 1;
			var NewNumberVisits = NewNumberVisits.toString();
			APP.updateSingleValueCookie(APP.props.$cn_NumberVisits, NewNumberVisits, 365*10);
		},
		// Zero Numerical Padding
		zeroPad: function(num, places) {
			var zero = places - num.toString().length + 1;
			return Array(+(zero > 0 && zero)).join("0") + num;
		}
	}
	return APP;
})();
AECustomDimension.init();
